// extracted by mini-css-extract-plugin
export default {"content":"ContactsPage_content__ffEV3","information-block":"ContactsPage_information-block__Oljl4"};